import axios from 'axios';

import getAuthSession from './auth';
import { QuestionnaireFailureContext } from '../interfaces/errors.interface';

export default async function logCloudWatchEvent(logGroup: string, logStream: string, message: string) {
  const authSession = await getAuthSession();
  await axios.post(
    `${process.env.REACT_APP_BASE_API}/cloudwatch-logging/`,
    { logGroup, logStream, message },
    {
      headers: { 'Authorization': `Bearer ${authSession.getIdToken().getJwtToken()}` },
    },
  );
}

export async function logQuestionnaireFailure(error: unknown, context: QuestionnaireFailureContext): Promise<void> {
  const response = (error as { response?: { status?: number, data?: unknown } })?.response;
  const logStream = `${process.env.REACT_APP_ENVIRONMENT?.toLocaleLowerCase() || 'dev'}-questionnaire-failures`;
  const message = JSON.stringify({
    ...context,
    status: response?.status,
    detail: response ? JSON.stringify(response.data) : String(error),
    path: window.location.pathname,
  });

  try {
    await logCloudWatchEvent('tpn-client/error-handler', logStream, message);
  } catch (err) {
    console.error('Error logging questionnaire failure to CloudWatch:', err);
  }
}